import { useShallowEffect } from '@mantine/hooks';
import { useMemo } from 'react';
import { useAppContainerContext } from './AppContainerContext';
import { ContentMeta } from './types';

export function useAppContainer() {
  const { mode, setMode, toggleMode, siestaMode, setSiestaMode } = useAppContainerContext();

  const isExpanded = useMemo(() => mode === 'expanded', [mode]);

  return {
    mode,
    setMode,
    toggleMode,
    isExpanded,
    siestaMode,
    setSiestaMode,
  };
}

export function useContentMeta(data: ContentMeta) {
  const { setContentMeta } = useAppContainerContext();

  useShallowEffect(() => {
    setContentMeta(data);
    return () => setContentMeta(null);
  }, [data, setContentMeta]);
}
